'use client';

import React from 'react';

import { useGlobalContext } from '@/lib/globalContext';
import {
  Column,
  Flex,
  Heading,
  Row,
  Separator,
  Spacer,
  variables,
} from 'politicamente-informados-ds';
import Image from 'next/image';
import Link from 'next/link';
import Social from '../Social/Social';
import { StyledFooter, StyledLinks } from './Footer.theme';

const Footer = () => {
  const state = useGlobalContext();
  const { menus = {} } = state;

  return (
    <footer id='site-footer'>
      <StyledFooter>
        <Row fluid={true}>
          <Column lg={12}>
            <Column lg={4} sm={6}>
              <Flex align='center' justify='center'>
                <Image
                  src={'/assets/logo-footer.svg'}
                  alt={process.env.NEXT_PUBLIC_SITE_NAME as string}
                  priority={true}
                  width={260}
                  height={50}
                  style={{
                    mixBlendMode: 'difference',
                  }}
                />
              </Flex>
            </Column>
          </Column>
        </Row>
        <Spacer customHeight='16px'></Spacer>
        <Row fluid={true}>
          <Column
            lg={4}
            sm={4}
            className='mb-4'
            style={{ alignItems: 'center' }}
          >
            <Flex gap='16px'>
              <div style={{ textAlign: 'center' }}>
                <Heading
                  size='texts'
                  tag='h3'
                  className='mb-4 mt-4'
                  style={{ color: 'white' }}
                >
                  Votar é participar! Com o teu voto podes fazer a diferença.
                </Heading>
              </div>

              <Flex
                direction='column'
                align='flex-start'
                gap='10px'
              >
                <Image
                  src={'/assets/logos.png'}
                  alt={process.env.NEXT_PUBLIC_SITE_NAME as string}
                  priority={true}
                  width={320}
                  height={44}
                  style={{
                    mixBlendMode: 'difference',
                  }}
                />
                <Column lg={12} sm={12}>
                  <Image
                    src={'/assets/smais-amporto.svg'}
                    alt='CM Matosinhos e S Mais Logo'
                    priority={true}
                    width={150}
                    height={39}
                  />
                </Column>
              </Flex>
            </Flex>
          </Column>
          <Column lg={1} sm={1} className='mb-4'></Column>
          <Column lg={2} sm={3} className='mb-4'>
            <Flex gap='16px' direction='column' align='flex-start'>
              {menus['footer-menu'] &&
                menus['footer-menu'].map((term) => (
                  <Link href={term.url as string} key={term!.id as number}>
                    <Heading tag='h6' size='texts'>
                      {(term.title as string).toLowerCase()}
                    </Heading>
                  </Link>
                ))}
            </Flex>
          </Column>
          <Column lg={1}></Column>
          <Column lg={3} sm={3} className='mb-4'>
            <Flex gap='16px' direction='column' align='flex-start'>
              <Image src="/assets/cmm-logo.png" alt={'Logo Camara Municipal Matosinhos'} width={188} height={33}/>
              <Heading tag='h6' size='texts'>
                Contactos:
              </Heading>
              <div>
                <Heading tag='h6' size='texts'>
                  Av. D. Afonso Henriques, 487
                </Heading>
                <Heading tag='h6' size='texts'>
                  4450-009 Matosinhos
                </Heading>
              </div>
              <Link href='mailto:juventudematosinhos@cm-matosinhos.pt'>
                <Heading size='captions' tag='h6'>
                  juventudematosinhos@cm-matosinhos.pt
                </Heading>
              </Link>
              <Social />
            </Flex>
          </Column>
          <Column lg={1}></Column>
        </Row>
        <Spacer customHeight='1rem' />
        <Row fluid={true}>
          <Column lg={12}>
            <Spacer customHeight='1rem' />
            <Separator height='1px' color='white' />
            <Spacer customHeight='1rem' />
            <Flex justify='space-between' style={{ padding: '0 1rem' }}>
              <Heading tag='p' size='captions'>
                {`Politicamente Informados Copyrights ${new Date().getFullYear()}`}
              </Heading>
              <StyledLinks>
                {menus['footer-terms'] &&
                  menus['footer-terms'].map((term) => (
                    <Link href={term.url as string} key={term!.id as number}>
                      <Heading tag='h6' size='captions'>
                        {term?.title as string}
                      </Heading>
                    </Link>
                  ))}
              </StyledLinks>
            </Flex>
          </Column>
        </Row>
      </StyledFooter>
    </footer>
  );
};

export default Footer;
